import { FC } from "react";
import { ExtraStateContext } from "..";
import { useProcess } from "../../../../process-context";
import LongTermContent from "./long-term/content";
import ShortTermContent from "./short-term/content";
import UpdateFieldsModal, { UpdateFieldsValues } from "./modal/update-card-modal";
import { CreateNotification } from "../../../../../../components/notifier";
import { SecurityControlCardRequestService } from "../../../../../../services/company-office/SecurityControlCardService";

const FormContent: FC = () => {
  const { Request, isLongTerm, openUpdateModal, setOpenUpdateModal, setSercurityControlCardRequest, reqDetail } =
    useProcess<ExtraStateContext>();

  const handleUpdate = (values: UpdateFieldsValues) => {
    const updateFields = { ...Request.fields };

    reqDetail.expiredDate = values.expiredDate.toDate().toISOString();
    if (values.otherPhoto?.length > 0) reqDetail.otherPhoto = values.otherPhoto.map((s) => s.response.data);

    const eContent: any[] = updateFields.eContent ? JSON.parse(updateFields.eContent) : null;

    const index = eContent.findIndex((s) => s.id === reqDetail.id);

    if (index > -1) {
      eContent[index] = { ...reqDetail };
    }
    updateFields.eContent = JSON.stringify(eContent);

    SecurityControlCardRequestService.updateSecurityControlCardRequest(Request.id, updateFields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Cập nhật thành công.`,
          icon: "/icons/success.png",
        });
        Request.fields.eContent = { ...updateFields.eContent };
        setSercurityControlCardRequest(Request);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Đã duyệt thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  return (
    <div>
      {isLongTerm ? <LongTermContent /> : <ShortTermContent />}{" "}
      <UpdateFieldsModal
        visible={!!openUpdateModal}
        onClose={() => setOpenUpdateModal(false)}
        onUpdate={handleUpdate}
        defaultValue={reqDetail}
      />
    </div>
  );
};

export default FormContent;
